// 时间戳转化为日期
const setTime = function (str,type){
    var n = parseInt(str)*1000;
    var D = new Date(n);
    var year = D.getFullYear();//四位数年份

    var month = D.getMonth()+1;//月份(0-11),0为一月份
    month = month<10?('0'+month):month;

    var day = D.getDate();//月的某一天(1-31)
    day = day<10?('0'+day):day;

    var hours = D.getHours();//小时(0-23)
    hours = hours<10?('0'+hours):hours;

    var minutes = D.getMinutes();//分钟(0-59)
    minutes = minutes<10?('0'+minutes):minutes;

    // var seconds = D.getSeconds();//秒(0-59)
    // seconds = seconds<10?('0'+seconds):seconds;
    // var week = D.getDay();//周几(0-6),0为周日
    // var weekArr = ['周日','周一','周二','周三','周四','周五','周六'];
    var now_time = year+'-'+month+'-'+day;
    if(type===1){
    }else if(type===2){
        now_time = hours+':'+minutes;
    }else if(type===3){
        now_time = year+'-'+month+'-'+day+' '+hours+':'+minutes;
    }else if(type===4){
        now_time = month+'-'+day
    }
    return now_time;
}
//字符串时间转化
const setStringTime = function(str){
    return str.substr(4,2)+"-"+str.substr(6,2)
}

//超过5位数单位转换成W
const setW=function(num){
    if(num > 9999){
        return (Math.floor(num/1000)/10) + 'w'
    }
    num=num.toString()
    return num
}
//三位数加个,
const setThousands=function(num) {
    var num = (num || 0).toString(), result = '';
    while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
    }
    if (num) { result = num + result; }
    return result;
}
//?
const arrayLine=function(arr){
    function compare(key){
      return function(value1,value2){
        var val1=value1[key];
          var val2=value2[key];
          return val1-val2;
      }
    }
    arr.sort(compare('value'));
    console.log(arr);
}
//数组求和
const arraySum=function(arr){
    let sum = 0
    arr.forEach(function(item){
        sum+=item
    })
    return sum
}
//数组最大值索引
const arrayMax= function(arr,index){
    let max = arr[0];
    for(let i = 1; i < arr.length; i++){
        if( max < arr[i] ){
            max = arr[i];
        }
    }
    if(index==='index'){
        return arr.indexOf(max)
    }
    return max
}
//数组对象最大值索引
const arraObjMax= function(arr){
    let maxIndex=0
    arr.map((item,i)=>{
        if(item.value>arr[maxIndex].value){
            maxIndex=i
        }
    })
    return maxIndex
}
//删除数组某个值
const arrayDel = function(val,arr){
    for (var i = 0; i < arr.length; i++) {
        if (arr[i] == val) arr.splice(i, 1);
    }
    return arr
}
//转化为百分数
const scale = function(value,int){
    let data
    if(int){
        //转化为百分数格式给echart(int)
        data = ((value-0)*100).toFixed(2)-0
    }else{
        //转化为百分数格式带%(string)
        data = ((value-0)*100).toFixed(2)+"%"
    }
    return data
}

var detailStartTime= ''

export default {
    setTime,
    setStringTime,
    setW,
    setThousands,
    arrayLine,
    arraySum,
    arrayMax,
    detailStartTime,
    scale,
    arraObjMax,
    arrayDel
}